import React from 'react'

import Layout from '../components/Layout'
import {Posts} from '../components/Main'

const News = ({ location }) => {
    return (
        <Layout location={location}>
            <Posts pageTitle={'News'} />
        </Layout>
    )
}

export default News
